export const regions = [
  { id: 23646, threadname: "Москва" },
  { id: 23648, threadname: "Московская область" },
  { id: 23649, threadname: "Санкт-Петербург" },
  { id: 23650, threadname: "Ленинградская область" },
  { id: 23719, threadname: "Краснодарский край" },
  { id: 23679, threadname: "Свердловская область" },
  { id: 23687, threadname: "Ростовская область" },
  { id: 23700, threadname: "Республика Татарстан" },
  { id: 23655, threadname: "Республика Башкортостан" },
  { id: 23684, threadname: "Самарская область" },
  { id: 23713, threadname: "Алтайский край" },
  { id: 23733, threadname: "Амурская область" },
  { id: 23735, threadname: "Архангельская область" },
  { id: 23737, threadname: "Астраханская область" },

  { id: 23739, threadname: "Белгородская область" },
  { id: 23741, threadname: "Брянская область" },
  { id: 23743, threadname: "Владимирская область" },
  { id: 23746, threadname: "Волгоградская область" },
  { id: 23747, threadname: "Вологодская область" },
  { id: 23745, threadname: "Воронежская область" },
  { id: 23660, threadname: "Донецкая Народная Республика" },
  { id: 23661, threadname: "Еврейская автономная область" },
  { id: 23714, threadname: "Забайкальский край" },
  { id: 23744, threadname: "Запорожская область" },
  { id: 23742, threadname: "Ивановская область" },
  { id: 23740, threadname: "Иркутская область" },
  { id: 23665, threadname: "Кабардино-Балкарская Республика" },
  { id: 23738, threadname: "Калининградская область" },
  { id: 23736, threadname: "Калужская область" },
  { id: 23717, threadname: "Камчатский край" },
  { id: 23683, threadname: "Карачаево-Черкесская Республика" },
  { id: 23734, threadname: "Кемеровская область" },
  { id: 23732, threadname: "Кировская область" },
  { id: 23728, threadname: "Костромская область" },

  { id: 23722, threadname: "Красноярский край" },
  { id: 23726, threadname: "Курганская область" },
  { id: 23724, threadname: "Курская область" },

  { id: 23721, threadname: "Липецкая область" },
  { id: 23690, threadname: "Луганская Народная Республика" },
  { id: 23720, threadname: "Магаданская область" },

  { id: 23718, threadname: "Мурманская область" },
  { id: 23659, threadname: "Ненецкий автономный округ" },
  { id: 23716, threadname: "Нижегородская область" },
  { id: 23715, threadname: "Новгородская область" },
  { id: 23712, threadname: "Новосибирская область" },
  { id: 23705, threadname: "Омская область" },
  { id: 23702, threadname: "Оренбургская область" },
  { id: 23698, threadname: "Орловская область" },
  { id: 23697, threadname: "Пензенская область" },
  { id: 23725, threadname: "Пермский край" },
  { id: 23727, threadname: "Приморский край" },
  { id: 23696, threadname: "Псковская область" },
  { id: 23653, threadname: "Республика Адыгея" },
  { id: 23654, threadname: "Республика Алтай" },
  { id: 23656, threadname: "Республика Бурятия" },
  { id: 23657, threadname: "Республика Дагестан" },
  { id: 23662, threadname: "Республика Ингушетия" },
  { id: 23682, threadname: "Республика Калмыкия" },
  { id: 23686, threadname: "Республика Карелия" },
  { id: 23688, threadname: "Республика Коми" },
  { id: 23689, threadname: "Республика Крым" },
  { id: 23692, threadname: "Республика Марий Эл" },
  { id: 23693, threadname: "Республика Мордовия" },

  { id: 23701, threadname: "Республика Тыва" },
  { id: 23706, threadname: "Республика Хакасия" },

  { id: 23685, threadname: "Рязанская область" },

  { id: 23681, threadname: "Саратовская область" },
  { id: 23695, threadname: "Республика Саха (Якутия)" },
  { id: 23680, threadname: "Сахалинская область" },

  { id: 23664, threadname: "Севастополь" },
  { id: 23699, threadname: "Республика Северная Осетия" },
  { id: 23678, threadname: "Смоленская область" },
  { id: 23729, threadname: "Ставропольский край" },
  { id: 23677, threadname: "Тамбовская область" },
  { id: 23676, threadname: "Тверская область" },
  { id: 23675, threadname: "Томская область" },
  { id: 23673, threadname: "Тюменская область" },
  { id: 23704, threadname: "Удмуртская Республика" },
  { id: 23672, threadname: "Ульяновская область" },
  { id: 23730, threadname: "Хабаровский край" },
  { id: 23658, threadname: "Ханты-Мансийский автономный округ" },
  { id: 23670, threadname: "Херсонская область" },
  { id: 23669, threadname: "Челябинская область" },
  { id: 23708, threadname: "Чеченская Республика" },
  { id: 23711, threadname: "Чувашская Республика" },
  { id: 23652, threadname: "Чукотский автономный округ" },
  { id: 23674, threadname: "Тульская область" },
  { id: 23651, threadname: "Ямало-Ненецкий автономный округ" },
  { id: 23667, threadname: "Ярославская область" },
];
